module.exports = __webpack_public_path__ + "static/media/38.d2d2ca4a.jpg";